import { IconProps } from "@chakra-ui/react";
import { assets } from "../assets";
// import { Role, useAuth } from "../Providers/AuthProvider";
import { useLocation } from "react-router-dom";

const { HomeFilled } = assets.iconComponents;

export const useMenu = () => {
  const pathName = useLocation().pathname;
  // const coursePath = "internal/courses";

  // const { role, isLoggedIn } = useAuth();
  const menu: IMenuItem<IconProps>[] = [
    {
      name: "Learn",
      icon: HomeFilled,
      path: "learn",
    },
    // {
    //   name: "Search",
    //   icon: SearchFilled,
    //   path: "search",
    // },
    // {
    //   name: "Courses",
    //   icon: GraduationFilled,
    //   path: "course",
    // },
    // {
    //   name: "Leagues",
    //   icon: ShieldFilled,
    //   path: "leagues",
    // },
    // ...(isLoggedIn
    //   ? [
    //       {
    //         name: "Profile",
    //         icon: PersonFill,
    //         path: "profile/me",
    //       },
    //     ]
    //   : []),
    // ...(role === Role.Admin || role === Role.Creator || role === Role.SuperAdmin
    //   ? [
    //       {
    //         name: "All Course",
    //         icon: GraduationFilled,
    //         path: coursePath,
    //       },
    //     ]
    //   : []),
    // ...(role === Role.Admin || role === Role.SuperAdmin
    //   ? [
    //       {
    //         name: "Users",
    //         icon: PersonFill,
    //         path: "internal/users",
    //       },
    //     ]
    //   : []),
  ];
  const rootUrl = pathName && pathName.split("/")[1];

  const isActive = (path: string) => {
    let active = false;

    let currentPath = pathName && pathName.split("/")[2];
    if (currentPath == "internal") {
      currentPath = pathName && pathName.split("/")[3];
      active = currentPath === path.split("/")[1];
    } else {
      active = currentPath === path.split("/")[0];
    }
    return active;
  };

  return { menu, isActive, rootUrl, currentPath: pathName };
};
